import React, {Fragment, useState} from "react";
import PageHeaderLayout from "../../../../layout/pageHeaderLayout";
import StandardTable, {StandardColumnsType} from "../../../../components/StandardTable";
import useAntTable from "../../../../utils/useAntTable";
import * as api from '../../../../apis/platforms/admin/financeReceipt'
import withAuth from "../../../../utils/withAuth";
import {Button, Divider, Input, message, Popconfirm, Space, Tag, UploadProps} from "antd";
import UploadModal from "../../../../components/UploadModal";
import {useRequest} from "ahooks";
import {useHistory} from "react-router-dom";
import dayjs from "dayjs";
import CategoryCascader from "../../../../components/CategoryCascader";
import DictSelect from "../../../../components/DictSelect";
import useQueryParam from "../../../../utils/useQueryParam";

const ImportButton = withAuth('import', Button)
const DeletePopconfirm = withAuth('delete', Popconfirm)

export default function FinanceReceipt() {
    const history = useHistory()
    const {refresh, search, form, tableProps} = useAntTable(api.getFinanceReceiptList, {method: 'post'})
    const [uploadModalVisible, setUploadModalVisible] = useState(false)

    useQueryParam(params => {
        const thisWeekNew = parseInt(params)==1 ?? false;
        form.setFieldValue('thisWeekNew', thisWeekNew);
    })

    const {run: doImportFinanceReceipt, loading: doImportFinanceReceiptLoading} = useRequest(api.importFinanceReceipt, {
        manual: true,
        onSuccess: () => {
            setUploadModalVisible(false)
            refresh()
        }
    })

    const {run: deleteFinanceReceipt} = useRequest(api.deleteReceipt, {
        manual: true,
        onSuccess: () => {
            message.success('删除成功')
            refresh()
        }
    })

    const columns = [
        {
            title: '收款编号',
            dataIndex: 'receiptNo'
        },
        {
            title: '客户名称',
            dataIndex: 'dealerName'
        },
        {
            title: '收款日期',
            dataIndex: 'receiptDate',
            render: (value: any) => dayjs(value).format('ll')
        },
        {
            title: '收款金额',
            dataIndex: 'receiptAmount'
        },
        {
            title: '已核销金额',
            dataIndex: 'writeOffAmountTotal'
        },
        {
            title: '单据类型',
            dataIndex: 'receiptType',
            render: (value: number) => {
                if (value === 0)
                    return <Tag color={"green"}>货款</Tag>
                else if (value === 10)
                    return <Tag color={"orange"}>退货单款</Tag>
            }
        },
        {
            title: '付款说明',
            dataIndex: 'paymentDesc'
        },
        {
            title: '核销状态',
            dataIndex: 'writeOffStatus',
            render: (value: number, record: any) => {
                if (record.manualSettlement) {
                    return <Tag color={"cyan"}>已结清</Tag>
                } else {
                    if (value === 0)
                        return <Tag color={"green"}>未核销</Tag>
                    else if (value === 10)
                        return <Tag color={"orange"}>部分核销</Tag>
                    else if (value === 20)
                        return <Tag color={"red"}>已核销</Tag>
                }
            }
        },
        {
            title: '操作',
            dataIndex: 'operations',
            render: (_: any, record: any) => (
                <Space split={<Divider type="vertical"/>}>
                    <a onClick={() => history.push(`/finance/receipt/detail/${record.id}`)}>详情</a>
                    {record.writeOffStatus === 0 && <DeletePopconfirm title={'确认删除收款单'}
                                                                onConfirm={() => deleteFinanceReceipt(record.id)}><a>删除</a></DeletePopconfirm>}
                </Space>
            )
        }
    ]

    const extSearchColumns: StandardColumnsType = [
        {
            dataIndex: 'receiptNo',
            title: '收款编号',
            search: {
                colSpan: 6
            }
        },
        {
            dataIndex: 'dealer',
            title: '客户名称或编号',
            search: {
                colSpan: 6
            }
        },
        {
            title: '日期范围',
            dataIndex: 'dateRange',
            search: {
                valueType: 'dateRange',
                colSpan: 6
            }
        },
        {
            dataIndex: 'receiptType',
            title: '单据类型',
            search: {
                valueType: 'select',
                valueEnum: [
                    {value: 0, text: '货款'},
                    {value: 10, text: '退货单款'},
                ],
                colSpan: 6
            }
        },
        {
            dataIndex: 'status',
            title: '状态',
            search: {
                valueType: 'select',
                valueEnum: [
                    {value: 0, text: '未核销'},
                    {value: 10, text: '部分核销'},
                    {value: 20, text: '已核销'},
                ],
                colSpan: 6
            }
        },
        {
            dataIndex: 'thisWeekNew',
            key: 'thisWeekNew',
            title: '本周新增',
            search: {
                valueType: 'check',
                colSpan: 6
            }
        }
    ];

    return (
        <PageHeaderLayout>
            <StandardTable rowKey={'id'} columns={columns} {...tableProps} extSearchColumns={extSearchColumns}
                           search={search} form={form} toolbar={
                <Space>
                    <ImportButton type={"primary"} onClick={() => setUploadModalVisible(true)}>导入</ImportButton>
                </Space>
            }/>
            <UploadModal onUpload={doImportFinanceReceipt}
                         open={uploadModalVisible}
                         title={'导入价格'}
                         template={'/template/收款单导入模板.xlsx'}
                         confirmLoading={doImportFinanceReceiptLoading}
                         onCancel={() => setUploadModalVisible(false)}/>
        </PageHeaderLayout>
    )
}
